import { Box, Skeleton } from "@mui/material";

function SkeletonAnimations() {
  return (
    <Box
      className="App"
      sx={{
        width: { xs: "90%", md: 600 },
        margin: "20px auto",
      }}
    >
      <Skeleton width="100%" height={30} />
      <Skeleton animation="wave" width="100%" height={30} />
      <Skeleton animation="wave" width="100%" height={30} />
      <Skeleton animation="wave" width="100%" height={30} />
      <Skeleton animation="wave" width="100%" height={30} />
      <Skeleton animation="wave" width="100%" height={30} />
      <Skeleton animation="wave" width="100%" height={30} />
      <Skeleton animation="wave" width="100%" height={30} />
      <Skeleton animation="wave" width="100%" height={30} />
      <Skeleton animation="wave" width="100%" height={30} />
      <Skeleton animation="wave" width="100%" height={30} />
      <Skeleton animation={false} width="100%" height={30} />
    </Box>
  );
}
export default SkeletonAnimations;
//
